import React from 'react';
import { motion } from 'framer-motion';
import { Container, Box, Typography, Grid } from '@mui/material';
import SearchForm from '../components/SearchForm';

const HomePage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #121212 0%, #1E1E1E 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Animated background elements */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden', zIndex: 0 }}>
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            style={{
              position: 'absolute',
              background: `rgba(108, 99, 255, ${Math.random() * 0.2})`,
              borderRadius: '50%',
              width: `${Math.random() * 100 + 50}px`,
              height: `${Math.random() * 100 + 50}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, Math.random() * 100 - 50],
              x: [0, Math.random() * 100 - 50],
              scale: [1, Math.random() + 0.5, 1],
            }}
            transition={{
              duration: Math.random() * 10 + 10,
              repeat: Infinity,
              repeatType: 'reverse',
            }}
          />
        ))}
      </Box>

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={4} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={10} lg={8}>
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Typography
                variant="h2"
                align="center"
                gutterBottom
                sx={{
                  fontWeight: 800,
                  mb: 2,
                  background: 'linear-gradient(45deg, #6C63FF 30%, #FF6584 90%)',
                  backgroundClip: 'text',
                  textFillColor: 'transparent',
                  textShadow: '0 10px 20px rgba(0,0,0,0.2)',
                  fontSize: {
                    xs: '2rem',
                    sm: '2.5rem',
                    md: '3rem',
                    lg: '3.5rem'
                  },
                  lineHeight: {
                    xs: 1.2,
                    sm: 1.3
                  },
                  wordBreak: 'break-word',
                  px: 1
                }}
              >
                OSINT Search Engine
              </Typography>
              <Typography
                variant="h5"
                align="center"
                color="text.secondary"
                paragraph
                sx={{ 
                  mb: 6, 
                  maxWidth: '800px', 
                  mx: 'auto',
                  fontSize: {
                    xs: '0.95rem',
                    sm: '1.1rem',
                    md: '1.25rem'
                  },
                  px: { xs: 2, sm: 3 },
                  lineHeight: {
                    xs: 1.4,
                    sm: 1.5
                  }
                }}
              >
                Search for information across multiple data sources using email, mobile number, name, and more.
              </Typography>
            </motion.div>
            
            <SearchForm />
          </Grid>
        </Grid>
      </Container>
      
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          textAlign: 'center',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          OSINT Search Engine &copy; {new Date().getFullYear()}
        </Typography>
      </Box>
    </Box>
  );
};

export default HomePage; 